import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { ContextApp } from '../../contexts/ContextApp';
import { Authorization } from '../../shared';
import { EnumsValues } from '../../enums/EnumsValues';
const DefaultRedirectPage = () => {
  const {
    user,
    functions,
    roles,
    isRequiredAcceptTemrsAndConditions,
    userHasAcceptedTermsAndConditions,
    selectedTenantIsChairAccount,
    selectedTenantIsExhibitorAccount,
  } = useContext(ContextApp);
  
  if (user) {
    if (
      !userHasAcceptedTermsAndConditions &&
      !Authorization.security(functions, EnumsValues.Functions.IsAdmin) &&
      isRequiredAcceptTemrsAndConditions
    )
      return <Redirect to="/app/termsAndPrivacy" />;
    
    // El rol "Administración" siempre aterriza en la grilla de solicitudes,
    // sin importar el tipo de cuenta (chair/exhibitor) asociada al tenant.
    if (
      roles?.some(
        (role) =>
          role.name
            ?.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase() === 'administracion',
      )
    ) {
      return <Redirect to="/app/membersManagement/request" />;
    }
    
    // Redirigir según el tipo de cuenta seleccionada
    if (selectedTenantIsChairAccount) {
      return <Redirect to="/app/boards/members" />;
    }
    
    if (selectedTenantIsExhibitorAccount) {
      return <Redirect to="/app/reunions/presentations" />;
    }
    
    return <Redirect to="/app/boards/indicators" />;
  } else {
    return <Redirect to="/login" />;
  }
};

export default DefaultRedirectPage;
